import { render } from "./LoginFormNew.vue?vue&type=template&id=2226d148&scoped=true&ts=true"
import script from "./LoginFormNew.vue?vue&type=script&lang=ts"
export * from "./LoginFormNew.vue?vue&type=script&lang=ts"

import "./LoginFormNew.vue?vue&type=style&index=0&id=2226d148&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2226d148"]])

export default __exports__